import { Box, Button, Typography } from '@mui/material';
import { DeleteIcon } from 'images/icons/DeleteIcon';
import { BLACK_ICON } from 'utilities/colors';
import React from 'react';

export const FilesList = ({
  classes,
  preparedForUpload,
  onDeleteFromUpload,
}) => (
  <Box className={classes.uploadedFilesList}>
    {preparedForUpload.map(({ fileName, icon, type }) => (
      <Box key={fileName} width="100%">
        <Box
          display="flex"
          flexDirection="row"
          alignItems="space-between"
          width="100%"
          height="3rem"
          marginBottom="1rem"
        >
          <Box width="100%" display="flex" alignItems="center">
            <Box width="3rem" height="3rem">
              <img
                src={icon}
                className={classes.providerIconLarge}
                alt={fileName}
              />
            </Box>
            <Box marginLeft="1rem">
              <Typography fontWeight="500">{fileName}</Typography>
            </Box>
          </Box>
          <Button
            className={classes.actionButton}
            onClick={() => onDeleteFromUpload(fileName, type)}
          >
            <DeleteIcon color={BLACK_ICON} />
          </Button>
        </Box>
      </Box>
    ))}
  </Box>
);
